/* ══════════════════════════════════════════════════════════════════
   complemnt — comportements des sections « mnt- »
   Un seul fichier, chargé une fois et mis en cache par le CDN Shopify.

   Chaque section porte data-mnt="<nom>" sur son élément racine ;
   le registre ci-dessous appelle l'initialisation correspondante,
   UNE SEULE FOIS par élément, et la rejoue quand l'éditeur de thème
   recharge une section.

   ⚠️ Tout est scopé à la racine reçue en paramètre (jamais de
   document.querySelector global) : deux instances de la même section
   sur une même page fonctionnent donc indépendamment.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var REG = {};
  function reg(nom, fn) { REG[nom] = fn; }

  /* ── petits utilitaires ───────────────────────────────────────── */
  var HAS_IO = 'IntersectionObserver' in window;

  function nb(el, attr, defaut) {
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? defaut : v;
  }
  function bool(el, attr, defaut) {
    var v = el.getAttribute(attr);
    return v === null ? defaut : (v === 'true' || v === '1');
  }
  /* allume tout, sans animation — repli navigateur ancien */
  function allume(liste, classe) {
    Array.prototype.forEach.call(liste, function (e) { e.classList.add(classe); });
  }

  /* Déplace une fenêtre modale à la racine de <body>.
     ⚠️ INDISPENSABLE : un ancêtre portant transform / filter /
     perspective / will-change crée un bloc conteneur, et position:fixed
     se comporte alors comme position:absolute — la fenêtre reste piégée
     dans la section, sous le header. */
  function versBody(modal, proprio) {
    if (!modal) return;
    if (proprio) modal.setAttribute('data-mnt-owner', proprio);
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
  }

  /* Ouverture / fermeture commune à toutes les fenêtres modales. */
  function brancheModale(root, modal) {
    if (!modal) return;
    var y = 0;

    function open(e) {
      if (e) e.preventDefault();
      y = window.pageYOffset;
      modal.hidden = false;
      /* deux images successives, sinon la transition ne démarre pas */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
      });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 350);
      window.scrollTo(0, y);
    }

    root.querySelectorAll('[data-mnt-open]').forEach(function (el) {
      el.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-mnt-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  /* Accordéon générique : <racine> contient des .<item> dont l'en-tête
     .<head> bascule la classe is-open. */
  function accordeon(root, selItem, selHead, solo) {
    var items = root.querySelectorAll(selItem);
    items.forEach(function (item) {
      var head = item.querySelector(selHead);
      if (!head) return;
      head.addEventListener('click', function () {
        var ouvre = !item.classList.contains('is-open');
        if (solo && ouvre) {
          items.forEach(function (autre) {
            if (autre === item) return;
            autre.classList.remove('is-open');
            var h = autre.querySelector(selHead);
            if (h) h.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', ouvre);
        head.setAttribute('aria-expanded', ouvre ? 'true' : 'false');
      });
    });
  }

  /* ══════════════════════════════════════════════════════════════
     1. mnt-gr — engagements qualité
     Les 6 pictos partent ENSEMBLE ; c'est le transition-delay du CSS
     qui fait la cascade. On observe donc la section, pas chaque picto.
     ══════════════════════════════════════════════════════════════ */
  reg('gr', function (root) {
    var items = root.querySelectorAll('.mnt-gr__item');
    if (!HAS_IO) return allume(items, 'is-in');

    new IntersectionObserver(function (entries, o) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        allume(items, 'is-in');
        o.unobserve(e.target);
      });
    }, { threshold: nb(root, 'data-seuil', 0.15), rootMargin: '0px 0px -50px 0px' })
      .observe(root);
  });

  /* ══════════════════════════════════════════════════════════════
     2. mnt-rs — « c'est pour vous ? »
     Une raison s'allume en entrant dans la bande centrale de l'écran
     et s'éteint en sortant.
     ⚠️ AUCUNE branche prefers-reduced-motion ici : elle allumait les
     4 lignes dès le chargement (bug déjà corrigé une fois).
     ══════════════════════════════════════════════════════════════ */
  reg('rs', function (root) {
    var items = root.querySelectorAll('.mnt-rs__item');
    if (!HAS_IO) return allume(items, 'is-on');

    var haut = root.getAttribute('data-haut') || '-20%';
    var bas = root.getAttribute('data-bas') || '-40%';
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-on', e.isIntersecting);
      });
    }, { rootMargin: haut + ' 0px ' + bas + ' 0px', threshold: 0 });

    items.forEach(function (i) { obs.observe(i); });
  });

  /* ══════════════════════════════════════════════════════════════
     3. mnt-rt — la routine (4 étapes)
     Apparition en cascade, une seule fois (unobserve).
     ══════════════════════════════════════════════════════════════ */
  reg('rt', function (root) {
    var cards = root.querySelectorAll('.mnt-rt__card');
    if (!HAS_IO) return allume(cards, 'is-in');

    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        o.unobserve(e.target);
      });
    }, { threshold: nb(root, 'data-seuil', 0.15), rootMargin: '0px 0px -50px 0px' });

    cards.forEach(function (c) { obs.observe(c); });
  });

  /* ══════════════════════════════════════════════════════════════
     4. mnt-ry — les bénéfices en cartes
     Sur mobile la piste défile : l'observateur prend la piste pour
     racine. Sur ordinateur c'est l'écran.
     ══════════════════════════════════════════════════════════════ */
  reg('ry', function (root) {
    var track = root.querySelector('.mnt-ry__track');
    if (!track) return;
    var cards = track.querySelectorAll('.mnt-ry__card');

    if (!HAS_IO || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return allume(cards, 'is-on');
    }
    var pc = window.innerWidth >= 768;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-on', e.isIntersecting);
      });
    }, {
      root: pc ? null : track,
      rootMargin: pc ? '0px 0px -15% 0px' : '0px',
      threshold: pc ? nb(root, 'data-seuil-pc', 0.3) : nb(root, 'data-seuil-mob', 0.6)
    });
    cards.forEach(function (c) { obs.observe(c); });
  });

  /* ══════════════════════════════════════════════════════════════
     5. mnt-md — les experts
     ══════════════════════════════════════════════════════════════ */
  reg('md', function (root) {
    var docs = root.querySelectorAll('.mnt-md__doc');
    if (!HAS_IO) return allume(docs, 'is-in');

    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        o.unobserve(e.target);
      });
    }, { threshold: nb(root, 'data-seuil', 0.15), rootMargin: '0px 0px -50px 0px' });
    docs.forEach(function (d) { obs.observe(d); });

    /* bouton facultatif : remonte vers le bloc d'achat */
    var btn = root.querySelector('[data-mnt-md-scroll]');
    if (btn) btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  /* ══════════════════════════════════════════════════════════════
     6. mnt-in — carrousel Instagram
     Le pas vaut une PAGE ENTIÈRE (largeur d'une tuile + gouttière,
     multiplié par --per-view) : les visuels défilent par rangée et
     aucun ne reste coupé sur les côtés.
     ══════════════════════════════════════════════════════════════ */
  reg('in', function (root) {
    var track = root.querySelector('.mnt-in__track');
    var prev = root.querySelector('.mnt-in__nav--prev');
    var next = root.querySelector('.mnt-in__nav--next');
    if (!track || !prev || !next) return;

    function pas() {
      var tile = track.querySelector('.mnt-in__tile');
      if (!tile) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var n = parseInt(getComputedStyle(root).getPropertyValue('--per-view'), 10) || 1;
      return (tile.getBoundingClientRect().width + gap) * n;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: pas(), behavior: 'smooth' }); });
  });

  /* ══════════════════════════════════════════════════════════════
     7. mnt-exp — carrousel d'avis en boucle infinie
     ⚠️ La gouttière est LUE dans le CSS calculé (et non recopiée en
     dur comme avant) : changer --gap dans les réglages ne désaligne
     plus la boucle.
     ══════════════════════════════════════════════════════════════ */
  reg('exp', function (root) {
    var track = root.querySelector('.mnt-exp__track');
    var group = track && track.querySelector('.mnt-exp__group');
    if (!track || !group) return;

    var vitesse = nb(root, 'data-vitesse', 0.5);
    var reprise = nb(root, 'data-reprise', 1500);

    /* On recopie le groupe autant de fois qu'il faut pour boucler sans trou.
       ⚠️ Si la piste n'est pas encore mise en page (largeur 0 : onglet
       caché, section repliée, rendu différé), scrollWidth vaut 0 et la
       condition serait fausse d'emblée — on ne clonerait rien et la
       boucle sauterait. On attend donc d'avoir une vraie largeur. */
    function remplir() {
      if (!track.clientWidth) return false;
      for (var i = 0; i < 6 && track.scrollWidth < track.clientWidth * 2; i++) {
        var copie = group.cloneNode(true);
        copie.setAttribute('aria-hidden', 'true');
        track.appendChild(copie);
      }
      return true;
    }

    function gap() { return parseFloat(getComputedStyle(track).columnGap) || 0; }

    var pos = track.scrollLeft, pause = false, minuteur;

    function pasApas() {
      if (!pause) {
        pos += vitesse;
        var largeur = group.offsetWidth + gap();
        if (pos >= largeur) pos -= largeur;      /* boucle invisible */
        track.scrollLeft = pos;
      } else {
        pos = track.scrollLeft;                  /* l'utilisateur a scrollé */
      }
      root._mntRaf = requestAnimationFrame(pasApas);
    }

    track.addEventListener('mouseenter', function () { pause = true; });
    track.addEventListener('mouseleave', function () { pause = false; });
    track.addEventListener('touchstart', function () {
      pause = true; clearTimeout(minuteur);
    }, { passive: true });
    track.addEventListener('touchend', function () {
      minuteur = setTimeout(function () { pause = false; }, reprise);
    });
    track.addEventListener('scroll', function () {
      if (pause && track.scrollLeft <= 0) track.scrollLeft = group.offsetWidth + gap();
    }, { passive: true });

    function demarrer() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // La boucle ne tourne QUE si la section est a l'ecran. Hors ecran elle
      // ne produisait qu'un commit de defilement + un repaint par image,
      // pendant toute la vie de la page. A la reprise on resynchronise pos
      // sur le scroll reel, exactement ce que fait deja la branche « pause »
      // du survol, donc aucun saut visible. Sans IntersectionObserver on
      // garde le comportement d'avant.
      if (!HAS_IO) return pasApas();
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!root._mntRaf) { pos = track.scrollLeft; pasApas(); }
          } else if (root._mntRaf) {
            cancelAnimationFrame(root._mntRaf);
            root._mntRaf = 0;
          }
        });
      }, { rootMargin: '200px 0px' }).observe(root);
    }

    if (remplir()) {
      demarrer();
    } else if ('ResizeObserver' in window) {
      /* la piste n'a pas encore de largeur : on repasse dès qu'elle en a une */
      var ro = new ResizeObserver(function () {
        if (remplir()) { ro.disconnect(); demarrer(); }
      });
      ro.observe(track);
    }
  });

  /* ══════════════════════════════════════════════════════════════
     8. mnt-ig — les actifs (cartes retournables) + panneau composition
     ══════════════════════════════════════════════════════════════ */
  reg('ig', function (root) {
    var cards = root.querySelectorAll('.mnt-ig__card');

    cards.forEach(function (card) {
      function bascule() { card.classList.toggle('is-flipped'); }
      card.addEventListener('click', bascule);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bascule(); }
      });
    });

    /* apparition en cascade, une seule fois */
    if (!HAS_IO) allume(cards, 'is-in');
    else new IntersectionObserver(function (entries, o) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        allume(cards, 'is-in');
        o.unobserve(e.target);
      });
    }, { threshold: nb(root, 'data-seuil', 0.15), rootMargin: '0px 0px -50px 0px' }).observe(root);

    /* le panneau vit à côté de la section, on l'envoie dans <body> */
    var modal = root.parentNode.querySelector('[data-mnt-modal]') ||
                document.querySelector('[data-mnt-modal][data-mnt-owner="' + root.id + '"]');
    versBody(modal, root.id);
    brancheModale(root, modal);
  });

  /* ══════════════════════════════════════════════════════════════
     9. mnt-fq — questions fréquentes
     ══════════════════════════════════════════════════════════════ */
  reg('fq', function (root) {
    accordeon(root, '.mnt-fq__item', '.mnt-fq__q', bool(root, 'data-solo', false));
  });

  /* ══════════════════════════════════════════════════════════════
     10. mnt-ct — page contact : la tuile FAQ déplie le volet
     ══════════════════════════════════════════════════════════════ */
  reg('ct', function (root) {
    var btn = root.querySelector('.mnt-ct__faqbtn');
    var box = root.querySelector('.mnt-ct__faq');
    var marge = nb(root, 'data-marge', 90);

    if (btn && box) {
      btn.addEventListener('click', function () {
        var ouvert = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        if (!ouvert) return;
        /* on attend que le volet ait commencé à s'ouvrir avant de
           mesurer sa position, sinon on vise l'ancienne. */
        setTimeout(function () {
          window.scrollTo({
            top: box.getBoundingClientRect().top + window.pageYOffset - marge,
            behavior: 'smooth'
          });
        }, 120);
      });
    }
    accordeon(root, '.mnt-ct__q', '.mnt-ct__qh', false);
  });

  /* ══════════════════════════════════════════════════════════════
     11. mnt-stars — la note en étoiles de la buy box
     Descend vers la vraie zone d'avis si elle existe.
     ══════════════════════════════════════════════════════════════ */
  /* Trustoo d'abord (l'appli installée ici), puis les autres widgets
     courants. Sans cette liste on retombait sur le bas de page. */
  var CIBLES_AVIS = ['#trustoo-widget-wrapper', '.trustoo-reviews-wrapper', '#reviews-wrapper',
    '[id*="cwilltrustoo"]', '#avis', '#reviews', '#judgeme_product_reviews', '.jdgm-rev-widget',
    '.yotpo-reviews', '.okeReviews', '[data-reviews]', '#shopify-product-reviews'];

  reg('stars', function (root) {
    var perso = root.getAttribute('data-cible');
    var decal = nb(root, 'data-decal', 60);

    function aller() {
      var liste = perso ? [perso].concat(CIBLES_AVIS) : CIBLES_AVIS;
      for (var i = 0; i < liste.length; i++) {
        var el = document.querySelector(liste[i]);
        if (el) {
          window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - decal, behavior: 'smooth' });
          return;
        }
      }
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
    root.addEventListener('click', aller);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); aller(); }
    });
  });

  /* ══════════════════════════════════════════════════════════════
     12. mnt-del — fourchette de livraison calculée en jours ouvrés
     Dimanches + jours fériés fédéraux canadiens toujours sautés ;
     samedi réglable. Les délais viennent des réglages de la section.
     ══════════════════════════════════════════════════════════════ */
  function paques(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100,
      d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451),
      mois = Math.floor((h + l - 7 * m + 114) / 31),
      jour = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mois - 1, jour);
  }
  function cle(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }

  /* Lundi à une date donnée ou juste avant. */
  function lundiAvant(y, m, jour) {
    var d = new Date(y, m, jour);
    while (d.getDay() !== 1) d.setDate(d.getDate() - 1);
    return d;
  }
  /* N-ième occurrence d'un jour de semaine dans un mois (0=dimanche..6=samedi). */
  function nEmeJour(y, m, jour, n) {
    var d = new Date(y, m, 1), c = 0;
    while (true) {
      if (d.getDay() === jour) { c++; if (c === n) return new Date(d); }
      d.setDate(d.getDate() + 1);
    }
  }

  var CACHE_FERIES = {};
  function feries(y) {
    if (CACHE_FERIES[y]) return CACHE_FERIES[y];
    var p = paques(y), set = {};
    function plus(n) { var d = new Date(p); d.setDate(d.getDate() + n); return cle(d); }

    /* jours fériés fixes — Canada (fédéral) */
    [[0, 1], [6, 1], [10, 11], [11, 25], [11, 26]]
      .forEach(function (x) { set[y + '-' + (x[0] + 1) + '-' + x[1]] = 1; });

    set[plus(-2)] = 1;                       /* Vendredi saint */
    set[cle(lundiAvant(y, 4, 24))] = 1;      /* Fête de la Reine/du Roi (lundi ≤ 24 mai) */
    set[cle(nEmeJour(y, 8, 1, 1))] = 1;      /* Fête du Travail (1er lundi de septembre) */
    set[cle(nEmeJour(y, 9, 1, 2))] = 1;      /* Action de grâce (2e lundi d'octobre) */

    CACHE_FERIES[y] = set;
    return set;
  }

  reg('del', function (root) {
    var el = root.querySelector('.mnt-del__dates');
    if (!el) return;

    var min = nb(root, 'data-min', 4);
    var max = nb(root, 'data-max', 7);
    var samedi = bool(root, 'data-samedi', true);
    var sep = root.getAttribute('data-sep') || ' – ';

    function ouvre(d) {
      var j = d.getDay();
      if (j === 0) return false;                  /* dimanche */
      if (!samedi && j === 6) return false;       /* samedi */
      return !feries(d.getFullYear())[cle(d)];    /* férié */
    }
    function ajoute(depart, n) {
      var d = new Date(depart), c = 0;
      while (c < n) { d.setDate(d.getDate() + 1); if (ouvre(d)) c++; }
      return d;
    }
    function format(d) {
      return d.toLocaleDateString('en-CA', { weekday: 'short', day: 'numeric', month: 'short' });
    }
    var now = new Date();
    el.textContent = format(ajoute(now, min)) + sep + format(ajoute(now, max));
  });

  /* ══════════════════════════════════════════════════════════════
     13. mnt-acc — menus réductibles de la buy box + popup composition
     ══════════════════════════════════════════════════════════════ */
  reg('acc', function (root) {
    accordeon(root, '.mnt-acc__item', '.mnt-acc__head', bool(root, 'data-solo', false));

    var modal = root.parentNode.querySelector('[data-mnt-modal]') ||
                document.querySelector('[data-mnt-modal][data-mnt-owner="' + root.id + '"]');
    versBody(modal, root.id);
    brancheModale(root, modal);
  });

  /* ══════════════════════════════════════════════════════════════
     14. mnt-produit — TÉLÉPORTATION dans la colonne d'achat

     sections/main-product.liquid pèse 482 Ko et n'est pas réécrivable :
     ses blocs HTML ne contiennent qu'une ancre vide [data-mnt-slot].
     La section « complemnt — Buy box » garde le vrai contenu dans un
     magasin caché, groupe par groupe ([data-mnt-into]), et on le clone
     dans l'ancre correspondante.

     ⚠️ Dans le magasin les éléments portent data-mnt-INIT et non
     data-mnt : sans ça le démarrage les initialiserait sur place
     (la fenêtre de composition partirait dans <body> AVANT le clonage)
     et cloneNode recopierait data-mnt-bound, laissant les copies mortes.
     ══════════════════════════════════════════════════════════════ */
  reg('produit', function (root) {

    function reveiller(copie) {
      var liste = [copie].concat(
        Array.prototype.slice.call(copie.querySelectorAll('[data-mnt-init]')));
      liste.forEach(function (e) {
        var n = e.getAttribute && e.getAttribute('data-mnt-init');
        if (n) { e.setAttribute('data-mnt', n); e.removeAttribute('data-mnt-init'); }
        if (e.removeAttribute) e.removeAttribute('data-mnt-bound');
      });
    }

    function placer() {
      /* on retire les fenêtres déjà téléportées par un placement précédent */
      Array.prototype.forEach.call(
        document.querySelectorAll('body > [data-mnt-modal][data-mnt-src="produit"]'),
        function (m) { m.remove(); });

      Array.prototype.forEach.call(root.querySelectorAll('[data-mnt-into]'), function (groupe) {
        var slot = document.querySelector('[data-mnt-slot="' + groupe.getAttribute('data-mnt-into') + '"]');
        if (!slot) return;
        slot.innerHTML = '';
        Array.prototype.forEach.call(groupe.children, function (enfant) {
          var copie = enfant.cloneNode(true);
          reveiller(copie);
          slot.appendChild(copie);
        });
        if (window.mntBoot) window.mntBoot(slot);
      });

      /* Le magasin conserve le balisage d'origine (il est en
         display:none). On lui retire ses id et aria-controls APRÈS le
         clonage : sans ça la page contiendrait chaque id en double, et
         les aria-controls des copies pointeraient vers les panneaux
         cachés du magasin au lieu des leurs. */
      Array.prototype.forEach.call(root.querySelectorAll('[id]'), function (e) {
        e.removeAttribute('id');
      });
      Array.prototype.forEach.call(root.querySelectorAll('[aria-controls]'), function (e) {
        e.removeAttribute('aria-controls');
      });
    }

    placer();
    /* l'éditeur de thème peut recharger main-product après nous */
    document.addEventListener('shopify:section:load', function () {
      setTimeout(placer, 60);
    });
  });

  /* ══════════════════════════════════════════════════════════════
     DÉMARRAGE
     ══════════════════════════════════════════════════════════════ */
  function boot(scope) {
    var racine = scope && scope.querySelectorAll ? scope : document;
    /* la racine elle-même peut porter data-mnt (cas d'un nœud cloné) */
    var liste = Array.prototype.slice.call(racine.querySelectorAll('[data-mnt]'));
    if (racine.nodeType === 1 && racine.hasAttribute && racine.hasAttribute('data-mnt')) liste.unshift(racine);

    liste.forEach(function (el) {
      var n = el.getAttribute('data-mnt');
      if (!REG[n] || el.dataset.mntBound) return;
      el.dataset.mntBound = '1';
      try { REG[n](el); }
      catch (err) { if (window.console) console.error('[mnt] ' + n, err); }
    });
  }
  window.mntBoot = boot;   /* utilisé par le téléport de la buy box */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* éditeur de thème : une section rechargée doit se rebrancher */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  /* éditeur de thème : une section retirée doit emporter sa fenêtre
     modale téléportée dans <body>, sinon elle s'accumule. */
  document.addEventListener('shopify:section:unload', function (e) {
    var ids = e.target.querySelectorAll ? e.target.querySelectorAll('[data-mnt]') : [];
    Array.prototype.forEach.call(ids, function (el) {
      var orphelin = document.querySelector('body > [data-mnt-modal][data-mnt-owner="' + el.id + '"]');
      if (orphelin) orphelin.remove();
      if (el._mntRaf) cancelAnimationFrame(el._mntRaf);
    });
  });

})();